var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "candidate-navbar" }, [
      _vm._m(0),
      _c("ul", { staticClass: "menu", attrs: { id: "collapse-menu" } }, [
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: { path: "/candidate/dl" } } }, [
              _vm._v(
                "DL 履歷 " + _vm._s(_vm.resumeCompleteness.DLCompleteness) + "%"
              ),
            ]),
          ],
          1
        ),
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: { path: "/candidate/idl" } } }, [
              _vm._v(
                "IDL 履歷 " +
                  _vm._s(_vm.resumeCompleteness.IDLCompleteness) +
                  "%"
              ),
            ]),
          ],
          1
        ),
        _c(
          "li",
          [
            _c(
              "router-link",
              { attrs: { to: { path: "/candidate/jobopening" } } },
              [_vm._v("職缺列表")]
            ),
          ],
          1
        ),
        _c(
          "li",
          [
            _c(
              "router-link",
              { attrs: { to: { path: "/candidate/applicationrecord" } } },
              [_vm._v("應徵紀錄")]
            ),
          ],
          1
        ),
        _c("li", [
          _c(
            "button",
            {
              attrs: { type: "button" },
              on: { click: _vm.openChangePasswordModal },
            },
            [_vm._v(" 變更密碼 ")]
          ),
        ]),
        _c("li", [
          _c(
            "button",
            { attrs: { type: "button" }, on: { click: _vm.logout } },
            [_vm._v("登出")]
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "changePasswordByOneself",
          tabindex: "-1",
          "aria-labelledby": "exampleModalLabel",
          "aria-hidden": "true",
          "data-backdrop": "static",
        },
      },
      [
        _c("img", {
          staticClass: "password_bg",
          attrs: { src: require("@/assets/img/password_bg.png"), alt: "" },
        }),
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered" },
          [
            _c("ValidationObserver", {
              ref: "changePassword",
              staticClass: "modal-content",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, reset }) {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return handleSubmit(_vm.changePassword)
                            },
                            reset: function ($event) {
                              $event.preventDefault()
                              return reset.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "password_bg_02",
                            attrs: {
                              src: require("@/assets/img/password_bg_02.png"),
                              alt: "",
                            },
                          }),
                          _c("div", { staticClass: "modal-header" }, [
                            _c("span", [_vm._v("變更密碼")]),
                          ]),
                          _c("div", { staticClass: "modal-body" }, [
                            _c(
                              "div",
                              { staticClass: "form-group form" },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#ff0000" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" 請輸入舊密碼 "),
                                ]),
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.trim",
                                                  value:
                                                    _vm.changePasswordData
                                                      .CurrentPassword,
                                                  expression:
                                                    "changePasswordData.CurrentPassword",
                                                  modifiers: { trim: true },
                                                },
                                              ],
                                              attrs: { type: "password" },
                                              domProps: {
                                                value:
                                                  _vm.changePasswordData
                                                    .CurrentPassword,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.changePasswordData,
                                                    "CurrentPassword",
                                                    $event.target.value.trim()
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-danger ml-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _c("span", { staticClass: "mark" }, [
                                    _vm._v("*"),
                                  ]),
                                  _vm._v(" 請輸入新密碼"),
                                  _c("span", { staticClass: "mark" }, [
                                    _vm._v("(長度須大於等於8)"),
                                  ]),
                                ]),
                                _c("ValidationProvider", {
                                  attrs: {
                                    name: "新密碼",
                                    vid: "confirmation",
                                    rules: "required|password_length:8",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.trim",
                                                  value:
                                                    _vm.changePasswordData
                                                      .NewPassword,
                                                  expression:
                                                    "changePasswordData.NewPassword",
                                                  modifiers: { trim: true },
                                                },
                                              ],
                                              attrs: { type: "password" },
                                              domProps: {
                                                value:
                                                  _vm.changePasswordData
                                                    .NewPassword,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.changePasswordData,
                                                    "NewPassword",
                                                    $event.target.value.trim()
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-danger ml-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("label", { attrs: { for: "" } }, [
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#ff0000" } },
                                    [_vm._v("*")]
                                  ),
                                  _vm._v(" 確認新密碼 "),
                                ]),
                                _c("ValidationProvider", {
                                  attrs: {
                                    name: "確認新密碼",
                                    rules: "required|confirmed:confirmation",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.trim",
                                                  value:
                                                    _vm.changePasswordData
                                                      .ConfirmPassword,
                                                  expression:
                                                    "changePasswordData.ConfirmPassword",
                                                  modifiers: { trim: true },
                                                },
                                              ],
                                              attrs: { type: "password" },
                                              domProps: {
                                                value:
                                                  _vm.changePasswordData
                                                    .ConfirmPassword,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.changePasswordData,
                                                    "ConfirmPassword",
                                                    $event.target.value.trim()
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text-danger ml-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "reset",
                                  "data-dismiss": "modal",
                                },
                              },
                              [_vm._v(" 取消 ")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "submit" },
                              },
                              [_vm._v("儲存")]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "syncResumeModal", tabindex: "-1" },
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c(
            "div",
            { staticClass: "modal-content" },
            [
              _c("ValidationObserver", {
                ref: "syncResume",
                staticClass: "modal-content",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ handleSubmit }) {
                      return [
                        _c("div", { staticClass: "modal-header" }, [
                          _c("h5", { staticClass: "modal-title" }, [
                            _vm._v("同步104履歷功能"),
                          ]),
                        ]),
                        _c("div", { staticClass: "modal-body" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("ValidationProvider", {
                                attrs: { name: "帳號", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("label", { attrs: { for: "" } }, [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(" 104 帳號： "),
                                          ]),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.syncData.User104Account,
                                                expression:
                                                  "syncData.User104Account",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "text" },
                                            domProps: {
                                              value:
                                                _vm.syncData.User104Account,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.syncData,
                                                  "User104Account",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("ValidationProvider", {
                                attrs: { name: "密碼", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors }) {
                                        return [
                                          _c("label", { attrs: { for: "" } }, [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v(" 104 密碼： "),
                                          ]),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.syncData.User104Password,
                                                expression:
                                                  "syncData.User104Password",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "password" },
                                            domProps: {
                                              value:
                                                _vm.syncData.User104Password,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.syncData,
                                                  "User104Password",
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                          _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _c("p", { staticClass: "mark" }, [
                            _vm._v(" 本功能不會留存您的帳號、密碼。"),
                            _c("br"),
                            _vm._v(
                              " 本功能無法同步使用Facebook註冊的104帳號，請見諒。 "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: {
                                type: "button",
                                "data-dismiss": "modal",
                              },
                            },
                            [_vm._v(" 取消 ")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return handleSubmit(_vm.syncResume)
                                },
                              },
                            },
                            [_vm._v(" 同步 ")]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn-menu",
        attrs: { id: "open-menu", "data-target": "#collapse-menu" },
      },
      [_c("span"), _c("span"), _c("span")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }